module.exports = __webpack_public_path__ + "static/media/foggy.c1936f1e.svg";